import { useTranslation } from "react-i18next";
import { IconButton } from "@/components/common/icon-button";
import { CheckCircle, ChevronLeftIcon, } from "lucide-react";
import { MoreActionItem, MoreActionPopover } from "@/components/common/more-action-popover";
import { MoreIcon, RenameIcon } from "@/components/ui/icon";
import { RenameModal } from "@/components/common/rename-modal";
import { PhotoIcon } from "@/components/assets-material-item/assets";
import { MultipleSelectIcon, PlusCircleIcon } from "@/components/assets-material/assets";
import { useToast } from "@/hooks/use-toast";
import { Upload } from '@/components/common/upload';
import { useNavigate } from "react-router-dom";
import { Tooltip } from "../ui/modal";
import { ALLOW_FILE_TYPES, MAX_FILE_SIZE } from "./constant";
import { FolderIcon } from "../assets/assets";

interface ItemHeaderProps {
  name: string;
  onUpload?: (files: File[]) => void;
}

export const ItemHeader = ({
  name,
  onUpload,
}: ItemHeaderProps) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleUpload = async (files: File[]) => {
    onUpload?.(files)
  }

  const handleInvalid = () => {
    toast.default({
      description: t("Please upload JPG, PNG, MP4, MOV files"),
    });
  }

  return (
    <header className=" sticky px-8 pt-3 pb-3 top-0 z-50 flex justify-between items-center select-none bg-gradient-to-b from-[#f9fafb] to-[#f9fafb]/0 backdrop-blur-sm">
      <div className="flex items-center gap-2">
        <IconButton
          icon={<FolderIcon className="size-5 text-[#333]" />}
          onClick={() => navigate('/assets/knowledge/')}
        />
        <IconButton
          className="size-7 group"
          icon={<ChevronLeftIcon className="text-[rgb(102,112,133,1)] group-hover:text-[#101828] transition-all" />}
          onClick={() => navigate(-1)}
        />
        <span className="px-2 py-1 bg-white rounded-[6px] font-semibold text-sm text-[#101828]">{name}</span>
      </div>
      {/* <Upload
        multiple
        acceptedFileTypes={ALLOW_FILE_TYPES.join(',')}
        minFileSize={0}
        maxFileSize={MAX_FILE_SIZE}
        onUpload={handleUpload}
        onInvalid={handleInvalid}
      >
        <Tooltip
          side="top"
          align="center"
          trigger={
            <IconButton
              className="size-8"
              icon={<PlusCircleIcon className="size-6" />}
            />

          }
          content={
            <div className='relative bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]'>
              <span className='text-[rgba(255,255,255,1)] text-sm font-medium'>
                {t('assets.knowledge_item.header.upload')}
              </span>
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-b-[6px] border-l-transparent border-r-transparent border-b-black"></div>
            </div>
          }
        />
      </Upload> */}
    </header>
  )
}